// extracted by mini-css-extract-plugin
export var contents = "style-module--contents--134ec";
export var name = "style-module--name--e0733";
export var talk = "style-module--talk--99a85";